import {ShippingErrorHandler} from "./ShippingErrorHandler";

export class ShippingFormValidator {
    static validateBarcode(barcode: string | null | undefined): string | null {
        if (!barcode || barcode.trim() === "") {
            ShippingErrorHandler.showWarning("Please enter a picking cart barcode");
            return null;
        }
        return barcode.trim();
    }

    static validateEpc(epc: string | null | undefined): string | null {
        if (!epc || epc.trim() === "") {
            ShippingErrorHandler.showWarning("Please enter a picked asset EPC or Serial Number");
            return null;
        }
        return epc.trim();
    }

    static validateAsset(asset: any): boolean {
        if (!asset || (!asset.id && !asset.epc)) {
            ShippingErrorHandler.showWarning("Cannot mark asset as shipped");
            return false;
        }
        return true;
    }

    static validateShopifyUrl(url: string | null | undefined): boolean {
        if (!url || url.trim() === "") {
            ShippingErrorHandler.showWarning("No Shopify order found for this asset");
            return false;
        }
        return true;
    }
}

